export interface AlertMessage {
  message: string;
  type: AlertType;
  duration?: number;
}

export enum AlertType {
  Information,
  Warning,
  Error,
}
